<template>
  <div v-bind:class="{ sorting, notSorting: !sorting }">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <template>
      <v-toolbar v-if="sorting" flat>
        <v-toolbar-title
        ><span class="text-body-1"
        >Categories are sorted according to the number shown, lowest to
            highest.</span
        ></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveSorting()"
        >Save
          <v-icon right dark> mdi-cloud-upload</v-icon>
        </v-btn
        >
      </v-toolbar>
      <v-treeview
        dense
        :items="categoriesTree"
        @input="change"
        :open="openCategories"
        :loading="loading"
      >
        <template v-slot:label="{ item }">
          <v-row v-if="sorting">
            <v-col cols="4">
              <v-subheader>{{ item.name }}</v-subheader>
            </v-col>
            <v-col cols="2">
              <v-text-field
                dense
                v-model="item.categoryOrdering"
                number
              ></v-text-field>
            </v-col>
          </v-row>
          <span v-else class="v-label theme--light text-body-1">
            <RouterLink :to="'/trade/category/' + item.id" class="category-link">
              <span :class="{
                'font-weight-bold': categoriesTree.some(root => root.id === item.id) || $route.params.categoryId === item.id,
                'text-caption': !categoriesTree.some(root => root.id === item.id)
              }">
                {{ item.name.toLowerCase().includes('special!') ? 'Specials' : item.name }}
              </span>
            </RouterLink>
          </span>
        </template>
      </v-treeview>
    </template>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import _ from 'lodash'

export default {
  props: ['sorting', 'selectedCategory'],
  data() {
    return {
      openCategories: [],
      loading: false,
    }
  },
  methods: {
    flattenMyTree(tree) {
      function recurse(nodes, path) {
        return _.map(nodes, function (node) {
          return [
            _.assign({}, _.omit(node, ['children', 'name'])),
            recurse(node.children),
          ]
        })
      }

      return _.flattenDeep(recurse(tree, []))
    },
    async saveSorting() {
      this.loading = true
      const flattened = this.flattenMyTree(this.categoriesTree)
      await this.$store.dispatch('updateCategoriesOrder', flattened)
      this.loading = false
    },
    change(categories) {
      this.$store.commit('UPDATE_QUERY_CATEGORIES', categories)
    },
  },
  computed: {
    ...mapState({
      categoriesTree: (state) => state.catalog.categoriesTree,
    }),
    ...mapGetters(['getQueryCategories', 'getQuery', 'getCategories']),
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('fetchCategories')
    this.loading = false
    this.openCategories = this.sorting
      ? []
      : this.getCategories.map((category) => category.id)
  },
}
</script>

<style lang="sass">
.notSorting .v-treeview .v-treeview-node__toggle
  display: none !important

.notSorting .v-treeview-node__level
  width: 0px !important

.notSorting .v-treeview--dense .v-treeview-node__root
  min-height: 30px !important
  padding: 0 !important

.notSorting .v-treeview--dense .v-treeview-node__children
  padding-left: 20px !important

.notSorting .v-treeview .v-treeview-node__checkbox
  margin-left: 0 !important

.notSorting .v-treeview-node__label .v-label > a > span
  font-size: 1.0em !important

.notSorting .v-treeview-node__label .v-label > a > span.font-weight-bold
  font-size: 1.1em !important

.category-link
  text-decoration: none !important
  color: inherit
</style>
